export default "__VITE_ASSET__ee60061b__"